"use client";

import { RASHI_DATA, STATUS_STYLES } from "./_data";

interface RashiPickerProps {
  selectedRashi: string | null;
  onSelect: (id: string | null) => void;
}

export function RashiPicker({ selectedRashi, onSelect }: RashiPickerProps) {
  const selectedData = selectedRashi ? RASHI_DATA.find((r) => r.id === selectedRashi) : null;

  return (
    <div className="card-sacred p-5 sm:p-6 mb-6">
      <p
        className="text-[13px] font-semibold text-center mb-4"
        style={{ color: "var(--ish-dark)" }}
      >
        Select your Moon sign to check instantly
      </p>
      <div className="grid grid-cols-4 sm:grid-cols-6 gap-2">
        {RASHI_DATA.map((rashi) => {
          const isActive = rashi.currentStatus !== "none";
          const isSelected = selectedRashi === rashi.id;
          return (
            <button
              key={rashi.id}
              onClick={() => onSelect(isSelected ? null : rashi.id)}
              className="flex flex-col items-center gap-0.5 p-2 rounded-lg text-center transition-all duration-150"
              style={{
                border: isSelected
                  ? "2px solid var(--ish-accent)"
                  : isActive
                    ? `1px solid ${STATUS_STYLES[rashi.currentStatus].border}`
                    : "1px solid var(--ish-border-light)",
                backgroundColor: isSelected
                  ? "var(--ish-accent-light)"
                  : isActive
                    ? STATUS_STYLES[rashi.currentStatus].bg
                    : "transparent",
              }}
            >
              <span
                className="text-[13px] font-bold"
                style={{
                  color: isActive ? STATUS_STYLES[rashi.currentStatus].text : "var(--ish-dark)",
                }}
              >
                {rashi.nameEn}
              </span>
              <span className="text-[10px]" style={{ color: "var(--ish-text-faint)" }}>
                {rashi.nameHi}
              </span>
            </button>
          );
        })}
      </div>

      {selectedData && (
        <div
          className="mt-4 p-4 rounded-lg"
          style={{
            backgroundColor:
              selectedData.currentStatus !== "none"
                ? STATUS_STYLES[selectedData.currentStatus].bg
                : "rgba(22,163,74,0.06)",
            border:
              selectedData.currentStatus !== "none"
                ? `1px solid ${STATUS_STYLES[selectedData.currentStatus].border}`
                : "1px solid rgba(22,163,74,0.25)",
          }}
        >
          <div className="flex items-center justify-between mb-2">
            <span
              className="text-[16px] font-bold"
              style={{
                color:
                  selectedData.currentStatus !== "none"
                    ? STATUS_STYLES[selectedData.currentStatus].text
                    : "var(--color-success-text-dark)",
              }}
            >
              {selectedData.nameEn} ({selectedData.nameHi})
            </span>
            {selectedData.currentStatus !== "none" ? (
              <span
                className="text-[11px] font-semibold px-2.5 py-1 rounded"
                style={{
                  backgroundColor: STATUS_STYLES[selectedData.currentStatus].badgeBg,
                  color: STATUS_STYLES[selectedData.currentStatus].badge,
                }}
              >
                {selectedData.currentStatus === "rising" && "RISING PHASE"}
                {selectedData.currentStatus === "peak" && "PEAK PHASE"}
                {selectedData.currentStatus === "setting" && "SETTING PHASE"}
              </span>
            ) : (
              <span
                className="text-[11px] font-semibold px-2.5 py-1 rounded text-green-700"
                style={{ backgroundColor: "rgba(22,163,74,0.12)" }}
              >
                NOT ACTIVE
              </span>
            )}
          </div>
          <p className="text-[13px]" style={{ color: "var(--ish-text-muted)" }}>
            {selectedData.currentStatus === "none"
              ? `You are not under Sade Sati. Next cycle: ${selectedData.approximatePeriod}.`
              : selectedData.currentStatus === "rising"
                ? "Saturn is in the 12th house from your Moon. This phase affects finances, sleep, and mental peace."
                : selectedData.currentStatus === "peak"
                  ? "Saturn is directly on your Moon sign — the most intense phase. Emotional heaviness and opportunities for deep growth."
                  : "Saturn is in the 2nd house from your Moon. Family, finances, and speech may be tested. Intensity easing."}
          </p>
          <p className="text-[12px] mt-1.5" style={{ color: "var(--ish-text-faint)" }}>
            Period: {selectedData.approximatePeriod}
          </p>
        </div>
      )}
    </div>
  );
}
